import { CommonModule, Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MenuToggleComponent } from '../menu-toggle/menu-toggle.component';

@Component({
  selector: 'app-main-header',
  standalone: true,
  imports:[MatButtonModule, MatIconModule, CommonModule, MenuToggleComponent],
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent {
  @Input() name_main: string = '...'
  @Input() subtitle?: string = undefined
  @Input() id_code?: number = undefined
  @Input() goBack: boolean = false
  @Input() noBackground: boolean = false;
  @Input() noSticky: boolean = false
  @Input() variant: 'solid' | 'transparent' | 'glass' = 'solid';

  constructor(private location: Location){
    // this.id_code = this.id_code
  }
  // name_main: string = 'nombre de la pagina'
  // id_code: string = '38e232c9-06cf-417c-98b7-3c2d10de4120'

  goback(): void {
    this.location.back()
  }

  ngOnInit(): void {
    // Compatibilidad retro: si viene noBackground, forzamos transparente.
    if (this.noBackground) this.variant = 'transparent';
  }
}
